/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ZonesOverviewResponse } from '../../models/zones-overview-response';

export interface GetOverviewZonesFacility$Params {
  facilityId: number;
  date?: string;
  dateTo?: string;
}

export function getOverviewZonesFacility(http: HttpClient, rootUrl: string, params: GetOverviewZonesFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<ZonesOverviewResponse>> {
  const rb = new RequestBuilder(rootUrl, getOverviewZonesFacility.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('date', params.date, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ZonesOverviewResponse>;
    })
  );
}

getOverviewZonesFacility.PATH = '/api/facilitygroup/overview/zones/facilityId/{facilityId}';
